import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { BzButton, BzChip, BzInputText, BzMasterAgGrid } from "../../../components";
import { updateActiveOrder } from "../../../redux/actions/mutualFund";
import OrderDetails from "./OrderDetails";
import OrderWatchListPopOver from "../../OrderWatchListPopOver";
import { MUTUAL_FUND_ORDERS_REF, setMutualFundOrdersGridRef } from "../../../utils/global_functions";


const orderMenu = [
    { label: 'Modify order', icon: 'icon-edit' },
    { label: 'Cancel order', icon: 'icon-close' },
    { label: 'Order Details', icon: 'icon-info' },
    { label: 'Fund Overview', icon: 'icon-overview' },
];

const sipMenu = [
    { label: 'Pause order', icon: 'icon-pause' },
    { label: 'Order Details', icon: 'icon-info' },
    { label: 'Fund Overview', icon: 'icon-overview' },
];
const objOrderTypes = {
    order: 1,
    sipInstructions: 2
};

const Orders = ({ isSuppressMenu, setIsSuppressMenu }) => {
    const dispatch = useDispatch();
    const { orders, activeOrderType, orderTypes } = useSelector(state => state.mutualFund);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const gridDetailCellRenderer = useMemo(() => OrderDetails, []);
    setMutualFundOrdersGridRef(useRef());
    useEffect(() => {
        setFilteredOrders(orders);

    }, [orders]);

    const filterOrdersType = useCallback((orderType) => {
        let objActiveOrder = {};
        if (orderTypes?.length > 0) {
            [objActiveOrder] = orderTypes.filter(elem => elem.id === orderType);
        } else {
            objActiveOrder = {};
        }
        dispatch(updateActiveOrder(objActiveOrder));
    }, [orderTypes, dispatch]);



    const GridHeaderSearch = ({ className, ...props }) => {
        return <BzInputText size="sm" className={`${className} scripname-searchtext`} type='search' placeholder='Search Funds' />;
    };

    const OrderStatus = ({ className, placement, children, setIsChartWidget, ...props }) => {
        return <div className='chips-wrap m-3'><BzChip className='chips bg-success bg-opacity-10 primary-chip text-success text-uppercase me-2'>{props?.value}</BzChip></div>;
    };
    const getCellRendererParams = (props) => {
        return {
            placement: 'right',
            activeOrderType: activeOrderType, isOrder: true, title: props?.data?.companyName, isBzChip: true, bzChipData: props?.data?.category, nav: props?.data?.nav, colLeft: 8, colRight: 4,
            children: <div>
                <div className='font-medium font-size4 color-text ms-3 text-uppercase'>{props.data.companyName}</div>
                <div className='chips-wrap flex-wrap'>
                    {props.data.category?.map((categoryName, index) => <BzChip key={index} className='chips primary-chip me-2 mb-2'>{categoryName}</BzChip>)}</div>
            </div>,
            bodyData: activeOrderType.id === objOrderTypes.order ? orderMenu : sipMenu
        };
    };


    const mutualFundOrderColumns = useMemo(() => {
        return [
            { field: "first", headerName: "", cellRenderer: 'agGroupCellRenderer' },
            { field: "dateTime", headerName: "DATE TIME", minWidth: 50 },
            {
                field: "companyName", headerComponent: GridHeaderSearch,
                cellRenderer: OrderWatchListPopOver, minWidth: 120, cellRendererParams: getCellRendererParams
            },
            { field: "type", headerName: "TYPE", minWidth: 50, cellClass: params => params.data.type === 'BUY' ? 'color-positive' : 'color-negative' },
            { field: "status", headerName: "STATUS", cellRenderer: OrderStatus },
            { field: "amount", headerName: "AMOUNT", minWidth: 50 },
            { field: "unit", headerName: "UNITS", minWidth: 50 },
            { field: "nav", headerName: "NAV", minWidth: 50 },
            { field: "frequency", headerName: "FREQUENCY", minWidth: 50 }
        ];
    }, [activeOrderType?.tabKey]);

    

    return (<>

        <Container fluid className='p-0'>
            <Row className='g-0 mb-4'>
                <Col md={10} className='d-flex justify-content-start align-items-center'>
                    <div className='submenu-wrapper d-flex justify-content-start align-items-center mt-3'>
                        {orderTypes?.map((newsType) => (
                            <BzChip key={newsType?.id} className={`submenuItem ${newsType?.id === activeOrderType?.id ? 'active' : null}`} onClick={() => { filterOrdersType(newsType?.id); }}>
                                {`${newsType?.name} (${newsType.count})`}
                            </BzChip>
                        ))}
                    </div>
                    {/* <div className='WatchlistTabs-wrapper watchlist-fixed'>                        
                            <BzTabs className='WatchlistTabs-wrap'>
                                {orderTypes?.map((newsType) => (
                                    <BzTab key={newsType?.id} className={`WatchlistTab ${newsType?.id === activeOrderType?.id ? 'active' : null}`} >
                                        {`${newsType?.name} (${newsType.count})`}
                                    </BzTab>
                                ))}
                            </BzTabs>                        
                        </div> */}
                </Col>
                <Col md={2} className='d-flex justify-content-end align-items-center'>
                    <BzButton className='btn btn-outline btn-md'>Cancel Order</BzButton>
                    {/* <div className='icon-14 icon-filter icon-dark ms-3' onClick={handleOnOrderFilter} /> */}
                </Col>
            </Row>
            <Row className='g-0'>
                <Col md={12} className='watchlist-grid-wrap d-flex justify-content-between'>
                    <BzMasterAgGrid ref={MUTUAL_FUND_ORDERS_REF}  arrColumnData={mutualFundOrderColumns} arrRowData={filteredOrders} isMasterDetail={true} isSuppressMenu={true} gridDetailCellRenderer={gridDetailCellRenderer} detailRowAutoHeight={true} rowHeight={70} style={{ minHeight: '50vh', width: '100%' }} className='ag-theme-alpine d-flex-1' />
                </Col>
            </Row>

        </Container>
    </>

    );
};
export default memo(Orders);